export default object => ({
  treatmentId: object.id,
  reference: object.reference,

  date: new Date(),
  responsibleId: null,
  comment: null,

  comments: object.progress.map(({ id, progressDate, description }) => ({
    id,
    progressDate,
    description,
  })),
});
